import { get } from 'lodash'

const getAsDate = (...args) => {
  const dateStr = get(...args)
  if (dateStr) return new Date(dateStr)
}

export default getAsDate
